import { storageService } from '../async-storage.service'

const STORAGE_KEY = 'posts'

export const postService = {
  query,
  getById,
  save,
  remove,
}

async function query(filterBy = {}) {
  try {
    const posts = await storageService.query(STORAGE_KEY)

    // סינון לפי כותרת ותגיות
    return posts.filter((post) => {
      const matchesTitle =
        !filterBy.title || post.title.includes(filterBy.title)
      const matchesTags =
        !filterBy.tags || filterBy.tags.every((tag) => post.tags.includes(tag))
      return matchesTitle && matchesTags
    })
  } catch (err) {
    console.error('Failed to get posts:', err)
    throw err
  }
}
function getById(postId) {
  try {
    return storageService.get(STORAGE_KEY, postId)
  } catch (err) {
    console.error(`Failed to get post with ID ${postId}:`, err)
    throw err
  }
}

async function remove(postId) {
  try {
    await storageService.remove(STORAGE_KEY, postId)
  } catch (err) {
    console.error(`Failed to remove post with ID ${postId}:`, err)
    throw err
  }
}
async function save(post) {
  try {
    let savedPost
    if (post._id) {
      savedPost = await storageService.put(STORAGE_KEY, post)
    } else {
      savedPost = await storageService.post(STORAGE_KEY, post)
    }
    return savedPost
  } catch (err) {
    console.error('Failed to save post:', err)
    throw err
  }
}
